import { render } from "./ZetaGlobalScript.vue?vue&type=template&id=4235cde2"
import script from "./ZetaGlobalScript.vue?vue&type=script&lang=js"
export * from "./ZetaGlobalScript.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__